<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="2" sm="3">
        <v-menu ref="month_menu" v-model="month_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.month" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.month" label="选择月份" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.month" type="month" no-title value="YYYY-mm" scrollable locale="zh-cn"
            @input="() => { $refs.month_menu.save(queryForm.month); month_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" sm="3">
        <a-space>
          <v-btn @click="getdata" color="primary" dark tile>
            <v-icon small>mdi-magnify</v-icon>查询
          </v-btn>
          <v-btn tile dark color="cyan" @click="updatebill"> 更新 </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <p v-if="total" class="text-h6">
      合计：
      <span class="success--text"> 合同收入({{ total.income }}) </span>,
      <span class="error--text"> 运费支出({{ total.cost }}) </span>,
      <span :class="{ 'success--text': total.profit > 0, 'error--text': total.profit < 0 }">
        公司利润({{ total.fprofit }})
      </span>,
      <span> 外包收入({{ total.income2 }}) </span>,
      <span> 外包运费({{ total.cost2 }}) </span>,
      <span :class="{ 'success--text': total.profit2 > 0, 'error--text': total.profit2 < 0 }">
        外包利润({{ total.fprofit2 }})
      </span>
    </p>
    <v-card tile>
      <a-table size="small" :columns="headers" :data-source="list" row-key="_id" :pagination="false" bordered
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }">
        <template slot="corp" slot-scope="text, record">
          {{ record.corp === '大方供应链' ? record.postline : record.corp }}
        </template>
        <template slot="income" slot-scope="text, record">
          <span class="success--text text-h6">{{ record.income }}</span>
        </template>
        <template slot="cost" slot-scope="text, record">
          <span class="error--text text-h6">{{ record.cost }}</span>
        </template>
        <template slot="profit" slot-scope="text, record">
          <span :class="{ 'text-h6': true, 'success--text': record.profit > 0, 'error--text': record.profit < 0 }">
            {{ record.profit }}
          </span>
        </template>
        <template slot="income2" slot-scope="text, record">
          <span class="text-h6">{{ record.income2 }}</span>
        </template>
        <template slot="cost2" slot-scope="text, record">
          <span class="text-h6">{{ record.cost2 }}</span>
        </template>
        <template slot="profit2" slot-scope="text, record">
          <span :class="{ 'text-h6': true, 'success--text': record.profit2 > 0, 'error--text': record.profit2 < 0 }">
            {{ record.profit2 }}
          </span>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn tile small text color="error" @click="showdetail(record)"> 明细 </v-btn>
          </a-space>
        </template>
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="detailmodal" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable
      max-width="1000px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon tile @click="detailmodal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>明细</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn tile text @click="downloaddetail"> 下载明细 </v-btn>
            <v-btn tile text @click="detailmodal = false"> 关闭 </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <a-table size="small" :columns="detailheaders" :data-source="detaillist" row-key="_id" :pagination="false"
              :locale="{ emptyText: '暂无数据' }" :scroll="{ x: detailwidth }">
              <template slot="customA">
                <p>邮局</p>
                <p>所属公司</p>
              </template>
              <template slot="customB">
                <p>邮路名称</p>
              </template>
              <template slot="customC">
                <p>流水号日期</p>
                <p>封车日期</p>
              </template>
              <template slot="customD">
                <p>流水号</p>
                <p>派车单号</p>
              </template>
              <template slot="customE">
                <p>车型</p>
                <p>要求派车吨位</p>
              </template>
              <template slot="customF">
                <p class="success--text">合同收入</p>
              </template>
              <template slot="customG">
                <p class="error--text">运费支出</p>
              </template>
              <template slot="customH">
                <p>公司利润</p>
              </template>
              <template slot="customI">
                <p>外包收入</p>
              </template>
              <template slot="customJ">
                <p>外包运费</p>
              </template>
              <template slot="customK">
                <p>外包利润</p>
              </template>
              <template slot="A" slot-scope="text, record">
                <p>{{ record.postoffice }}</p>
                <p>{{ record.corp }}</p>
              </template>
              <template slot="B" slot-scope="text, record">
                <p>{{ record.postroute }}</p>
              </template>
              <template slot="C" slot-scope="text, record">
                <p>{{ record.serial_day }}</p>
                <p>{{ record.block_day }}</p>
              </template>
              <template slot="D" slot-scope="text, record">
                <p>{{ record.serial_no }}</p>
                <p>{{ record.dispatch_no }}</p>
              </template>
              <template slot="E" slot-scope="text, record">
                <p>{{ record.vehicle_type }}</p>
                <p>{{ record.request_weight }}</p>
              </template>
              <!--合同收入-->
              <template slot="F" slot-scope="text, record">
                <p class="success--text">
                  {{ record.real_oilfreight1 || record.real_freight1 }}
                </p>
              </template>
              <!--运费支出(下游运费，自营调车运费，外包合同价)-->
              <template slot="G" slot-scope="text, record">
                <p v-if="record.isself" class="error--text">
                  {{ (record.out_freight > 0 ? record.out_freight : record.real_freight2_947) }}
                </p>
                <p v-else class="error--text">
                  {{ record.real_freight2 }}
                </p>
              </template>
              <!--公司利润-->
              <template slot="H" slot-scope="text, record">
                <p :class="{
                  'font-weight-bold': true,
                  'error--text': record.profit < 0,
                  'success--text': record.profit > 0
                }">
                  {{ record.profit }}
                </p>
              </template>
              <!--外包收入-->
              <template slot="I" slot-scope="text, record">
                <p v-if="record.out_freight > 0">
                  {{ record.out_freight }}
                </p>
              </template>
              <!--外包运费-->
              <template slot="J" slot-scope="text, record">
                <p v-if="record.out_freight > 0">
                  {{ record.real_freight2_947 }}
                </p>
              </template>
              <!--外包利润-->
              <template slot="K" slot-scope="text, record">
                <p :class="{
                  'font-weight-bold': true,
                  'success--text': record.profit2 > 0,
                  'error--text': record.profit2 < 0
                }">
                  {{ record.profit2 }}
                </p>
              </template>
            </a-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bydetailmodal" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable
      max-width="1000px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon tile @click="bydetailmodal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>明细</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn tile text @click="downloaddetail"> 下载明细 </v-btn>
            <v-btn tile text @click="bydetailmodal = false"> 关闭 </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <a-table size="small" :columns="bydetailheaders" :data-source="bydetaillist" row-key="_id"
              :pagination="false" :locale="{ emptyText: '暂无数据' }" :scroll="{ x: bydetailwidth }">
              <template slot="driver">
                <p>司机姓名</p>
                <p>司机电话</p>
                <p>车牌号</p>
              </template>
              <template slot="income">
                <p class="success--text">合计收入</p>
              </template>
              <template slot="cost">
                <p class="error--text">合计成本</p>
              </template>
              <template slot="driver" slot-scope="text, record">
                <p>{{ record.driver_name }}</p>
                <p>{{ record.driver_mobile }}</p>
                <p>{{ record.carnumber }}</p>
              </template>
              <template slot="income" slot-scope="text, record">
                <p class="success--text">
                  {{ record.income }}
                </p>
              </template>
              <template slot="cost" slot-scope="text, record">
                <p class="error--text">
                  {{ record.cost }}
                </p>
              </template>
              <template slot="profit" slot-scope="text, record">
                <p :class="{
                  'font-weight-bold': true,
                  'error--text': record.profit < 0,
                  'success--text': record.profit > 0
                }">
                  {{ record.profit }}
                </p>
              </template>
            </a-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "FinanceReport",
  data() {
    return {
      queryForm: {
        month: this.$moment().format('YYYY-MM'),
      },
      month_menu: false,
      headers: [
        { title: "项目/线路", dataIndex: "corp", scopedSlots: { customRender: "corp" }, width: 120, align: "center" },
        { title: "月份", dataIndex: "month", scopedSlots: { customRender: "month" }, width: 100, align: "center" },
        { title: '合同收入', dataIndex: 'income', scopedSlots: { customRender: "income" }, width: 150, align: "center" },
        { title: '运费支出', dataIndex: 'cost', scopedSlots: { customRender: "cost" }, width: 150, align: "center" },
        { title: "公司利润", dataIndex: "profit", scopedSlots: { customRender: "profit" }, width: 150, align: "center" },
        { title: '外包收入', dataIndex: 'income2', scopedSlots: { customRender: "income2" }, width: 150, align: "center" },
        { title: '外包运费', dataIndex: 'cost2', scopedSlots: { customRender: "cost2" }, width: 150, align: "center" },
        { title: "外包利润", dataIndex: "profit2", scopedSlots: { customRender: "profit2" }, width: 150, align: "center" },
        { title: "趟次", dataIndex: "count", scopedSlots: { customRender: "count" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 150, align: "center", fixed: 'right' },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      vrules: {
        required: (value) => !!value || "不能为空"
      },
      detailform: {},
      detailheaders: [
        { dataIndex: "A", slots: { title: "customA" }, scopedSlots: { customRender: "A" }, width: 120, align: "center" },
        { dataIndex: "B", slots: { title: "customB" }, scopedSlots: { customRender: "B" }, width: 120, align: "center" },
        { dataIndex: "C", slots: { title: "customC" }, scopedSlots: { customRender: "C" }, width: 120, align: "center" },
        { dataIndex: "D", slots: { title: "customD" }, scopedSlots: { customRender: "D" }, width: 120, align: "center" },
        { dataIndex: "E", slots: { title: "customE" }, scopedSlots: { customRender: "E" }, width: 120, align: "center" },
        { dataIndex: "F", slots: { title: "customF" }, scopedSlots: { customRender: "F" }, width: 120, align: "center" },
        { dataIndex: "G", slots: { title: "customG" }, scopedSlots: { customRender: "G" }, width: 120, align: "center" },
        { dataIndex: "H", slots: { title: "customH" }, scopedSlots: { customRender: "H" }, width: 120, align: "center" },
        { dataIndex: "I", slots: { title: "customI" }, scopedSlots: { customRender: "I" }, width: 150, align: "center" },
        { dataIndex: "J", slots: { title: "customJ" }, scopedSlots: { customRender: "J" }, width: 120, align: "center" },
        { dataIndex: "K", slots: { title: "customK" }, scopedSlots: { customRender: "K" }, width: 120, align: "center" },
      ],
      detaillist: [],
      detailmodal: false,
      bydetailheaders: [
        { title: "发货日期", dataIndex: "date", scopedSlots: { customRender: "date" }, width: 120, align: "center" },
        { title: "线路", dataIndex: "postline_by", scopedSlots: { customRender: "postline_by" }, width: 120, align: "center" },
        { dataIndex: "driver", slots: { title: "driver" }, scopedSlots: { customRender: "driver" }, width: 120, align: "center" },
        { title: "收入", dataIndex: "ifee1", scopedSlots: { customRender: "ifee1" }, width: 120, align: "center" },
        { title: "卸货加点费", dataIndex: "ifee2", scopedSlots: { customRender: "ifee2" }, width: 120, align: "center" },
        { title: "卸货费", dataIndex: "ifee3", scopedSlots: { customRender: "ifee3" }, width: 120, align: "center" },
        { title: "临时加短驳车实报实销", dataIndex: "ifee4", scopedSlots: { customRender: "ifee4" }, width: 120, align: "center" },
        { dataIndex: "income", slots: { title: "income" }, scopedSlots: { customRender: "income" }, width: 120, align: "center" },
        { title: "支出", dataIndex: "cfee1", scopedSlots: { customRender: "cfee1" }, width: 120, align: "center" },
        { title: "卸货加点费", dataIndex: "cfee2", scopedSlots: { customRender: "cfee2" }, width: 120, align: "center" },
        { title: "卸货费", dataIndex: "cfee3", scopedSlots: { customRender: "cfee3" }, width: 120, align: "center" },
        { title: "临时加短驳车实报实销", dataIndex: "cfee4", scopedSlots: { customRender: "cfee4" }, width: 120, align: "center" },
        { dataIndex: "cost", slots: { title: "cost" }, scopedSlots: { customRender: "cost" }, width: 120, align: "center" },
        { title: "利润", dataIndex: "profit", scopedSlots: { customRender: "profit" }, width: 120, align: "center" },
      ],
      bydetaillist: [],
      bydetailmodal: false,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    detailwidth() {
      return _.reduce(this.detailheaders, (a, b) => a + (b.width || 300), 0);
    },
    bydetailwidth() {
      return _.reduce(this.bydetailheaders, (a, b) => a + (b.width || 300), 0);
    },
    total() {
      let total = {
        income: this.$d(),
        cost: this.$d(),
        profit: this.$d(),
        fprofit: '',
        income2: this.$d(),
        cost2: this.$d(),
        profit2: this.$d(),
        fprofit2: '',
      };
      for (let i = 0; i < this.list.length; i++) {
        let {
          income,
          cost,
          profit,
          income2,
          cost2,
          profit2,
        } = this.list[i];
        total.income = total.income.plus(income);
        total.cost = total.cost.plus(cost);
        total.profit = total.profit.plus(profit);
        total.income2 = total.income2.plus(income2);
        total.cost2 = total.cost2.plus(cost2);
        total.profit2 = total.profit2.plus(profit2);
      }
      total.income = this.$utils.formatMoney(total.income.toString(), 2, '');
      total.cost = this.$utils.formatMoney(total.cost.toString(), 2, '');
      total.fprofit = this.$utils.formatMoney(total.profit.toString(), 2, '');
      total.income2 = this.$utils.formatMoney(total.income2.toString(), 2, '');
      total.cost2 = this.$utils.formatMoney(total.cost2.toString(), 2, '');
      total.fprofit2 = this.$utils.formatMoney(total.profit2.toString(), 2, '');
      return total;
    },
  },
  components: {},
  watch: {
    page() {
      this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 250;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 250;
    };
    this.page = 1;
    this.list = []
    this.length = 0;
    this.queryForm = {
      month: this.$moment().format('YYYY-MM')
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/billreport/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showdetail(item) {
      this.detailform = {
        month: item.month,
        postofficeid: item.postofficeid,
        dispatch_response_corp: item.dispatch_response_corp,
        corp: item.corp,
        postlineid: item.postlineid,
      };
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/billreport/detail", { ...this.detailform }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (item.corp === '泌阳') {
            this.bydetaillist = res.data.list;
            this.bydetailmodal = true;
            return;
          }
          this.detaillist = res.data.list;
          this.detailmodal = true;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    downloaddetail() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/billreport/detail", { ...this.detailform, action: "download" }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    download() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/billreport/list", { ...this.queryForm, action: 'download' }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    updatebill() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/billreport/update", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    lockbill() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/billreport/lock", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    unlockbill() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/billreport/unlock", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

/deep/ .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  padding: 0 4px;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
